import * as React from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

/** An inline text action: the `link` Button without its box. */
export function LinkButton({
  className,
  ...props
}: React.ComponentProps<typeof Button>) {
  return (
    <Button
      type="button"
      variant="link"
      size="sm"
      className={cn('h-auto p-0', className)}
      {...props}
    />
  )
}
